import { useEffect, useRef } from 'react';
import { Folder, Music, Sword, Footprints, Trees, Wind, Waves, Zap, Shield, Crown } from 'lucide-react';

interface IconSelectorProps {
    position: {
        x: number;
        y: number;
    };
    onSelect: (iconName: string) => void;
    onClose: () => void;
}

export function IconSelector({ position, onSelect, onClose }: IconSelectorProps) {
    const iconSelectorRef = useRef<HTMLDivElement>(null);

    const icons = [
        { name: 'folder', component: Folder },
        { name: 'music', component: Music },
        { name: 'sword', component: Sword },
        { name: 'footprints', component: Footprints },
        { name: 'trees', component: Trees },
        { name: 'wind', component: Wind },
        { name: 'waves', component: Waves },
        { name: 'zap', component: Zap },
        { name: 'shield', component: Shield },
        { name: 'crown', component: Crown },
    ];

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (iconSelectorRef.current && !iconSelectorRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    return (
        <div
            ref={iconSelectorRef}
            className="fixed z-50 bg-surface rounded-lg border border-border shadow-xl p-3 animate-scale-in"
            style={{
                left: position.x,
                top: position.y,
            }}
        >
            <div className="grid grid-cols-5 gap-1">
                {icons.map(({ name, component: IconComponent }) => (
                    <button
                        key={name}
                        onClick={() => onSelect(name)}
                        className="p-2 rounded hover:bg-surface-hover transition-all duration-200 hover:scale-105 active:scale-95"
                        title={`Select ${name} icon`}
                    >
                        <IconComponent size={16} className="text-muted-foreground hover:text-foreground transition-colors duration-200" />
                    </button>
                ))}
            </div>
        </div>
    );
} 